import { defineStore } from "pinia";
import { useMultiAdditionalServiceField } from "@/features/experience-curation/lib/useAdditionalServiceField";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";

export const useCurationHealthAndSafetyTags = defineStore("curation-distribution-tags-health-and-safety-field", () => {
  const field = useMultiAdditionalServiceField({
    id: "health_and_safety_tags",
    functionalGroupCode: "HEALTH_AND_SAFETY_TAGS",
  });
  const hasUnpublishedChange = useHasFunctionalFieldChange("health_and_safety_tags");

  return { ...field, hasUnpublishedChange };
});
